/**
 * 页面标题区（旧 components/common/PageHeader.vue）：标题、副标题、返回按钮、右侧操作区
 */
import type { ReactNode } from 'react'
import { Button, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import styles from './PageHeader.module.css'

interface PageHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  onBack?: () => void
  extra?: ReactNode
}

export function PageHeader({ title, subtitle, onBack, extra }: Readonly<PageHeaderProps>) {
  return (
    <div className={styles.header}>
      <div className={styles.heading}>
        {onBack && <Button type="text" aria-label="返回" icon={<ArrowLeftOutlined />} onClick={onBack} />}
        <Typography.Title level={4} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        {subtitle && <Typography.Text type="secondary">{subtitle}</Typography.Text>}
      </div>
      {extra && <div>{extra}</div>}
    </div>
  )
}
